<template>
  <div v-if="currentTrail == null">Loading</div>
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between">
            <div>
              <h3 class="card-title text-primary mb-0">Editar sendero</h3>
              <div class="sub-line"></div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-sm mx-60">
                <trail-form :entity="currentTrail" action="update" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import TrailForm from "./TrailForm.vue";


    const store = useStore();
    const route = useRoute();


    const getCurrentTrail= async (id) => {
      return await store.dispatch("trail/getTrailById", id);
    };

    const currentTrail = computed(() => {
      if(!store.state.trail.currentTrail) return null
      let trail = store.state.trail.currentTrail
      if( trail.naturalSpace && trail.naturalSpace['@id']){
        trail.naturalSpace = trail.naturalSpace['@id']
      }

      return trail
    });

    onMounted(() => {
      getCurrentTrail(route.params.id)
    });



</script>
